var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6Zm0 10.8c2.652 0 4.8-2.148 4.8-4.8 0-2.652-2.148-4.8-4.8-4.8A4.799 4.799 0 0 0 1.2 6c0 2.652 2.148 4.8 4.8 4.8Zm2.122-7.77.848.848L6 6.848 5.152 6l2.97-2.97Z",
    fill: "#4B4F54"
  })));
};
export default SvgClock;